import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import { UserPermissionByIdResponse } from "../../types/permissionTypes";
import { Response } from "../../types/serviceTypes";
import type { State } from "../../types/state/stateTypes";
import { getUserPermissionByIdSlice } from "../../services/userPermission/sliceService";

//REFACTOR: Mover informações do usuario logado para esse slice
export interface UserState {
  userPermission: Response<UserPermissionByIdResponse>;
}

export const userSlice = createSlice({
  name: "user",
  initialState: {
    userPermission: {
      loading: true,
    },
  } as UserState,
  reducers: {
    setUserPermission: (state, action) => {
      state.userPermission = action.payload;
    },
  },
});

export const fetchUserPermissionById = createAsyncThunk(
  "user/userPermission",
  async (user_id: string, { dispatch }) => {
    dispatch(
      userSlice.actions.setUserPermission({
        data: undefined,
        loading: true,
        error: false,
      }),
    );
    const res = await getUserPermissionByIdSlice(user_id);
    dispatch(
      userSlice.actions.setUserPermission({
        data: res,
        loading: false,
        error: false,
      }),
    );
  },
);

export const userPermissionSelector = (state: State) =>
  state.user.userPermission.data;
export const userPermissionSelectorAll = (state: State) =>
  state.user.userPermission;

export const permissionsSelector = (state: State) =>
  state.user.userPermission.data?.user_groups;

export const actions = {
  ...userSlice.actions,
};

export const thunks = {
  fetchUserPermissionById,
};
